import { render, staticRenderFns } from "./landscape-thumb-carousel.vue?vue&type=template&id=2e9b9af2&scoped=true"
import script from "./landscape-thumb-carousel.vue?vue&type=script&lang=js"
export * from "./landscape-thumb-carousel.vue?vue&type=script&lang=js"
import style0 from "./landscape-thumb-carousel.vue?vue&type=style&index=0&id=2e9b9af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9b9af2",
  null
  
)

export default component.exports